import Vue from "vue";
import VueRouter from "vue-router";
import NProgress from "nprogress";
import paths from "./paths";
import store from "@/store/index";
import { getAuthToken } from "@/utils/helpers";

Vue.use(VueRouter);

// Per-tenant name, same source the login screen and the built index.html use.
const APP_NAME = process.env.VUE_APP_TITLE || "Credit Union Admin Portal";

const Router = new VueRouter({
  base: "/",
  mode: "history",
  linkActiveClass: "active",
  routes: paths
});

Router.beforeEach((to, from, next) => {
  if (to.name) {
    NProgress.start();
    NProgress.inc(0.0);
  }
  if (to.matched.some(record => record.meta.requiresAuth) && !getAuthToken()) {
    store.dispatch("resetSnackBarState", null, { root: true });
    return next({ name: "account.login" });
  }
  next();
});

Router.afterEach(to => {
  // Complete animation of the router progress bar
  NProgress.done();

  // Nearest matched route wins, so child routes override their parent.
  const page = [...to.matched]
    .reverse()
    .map(record => record.meta && record.meta.title)
    .find(Boolean);
  document.title = page ? `${page} · ${APP_NAME}` : APP_NAME;
});

export default Router;
